export const SEARCH_BY_PARAMS_LOCAL_STORAGE_KEY = 'by_params_search_state';
export const SEARCH_BY_OFFERS_LOCAL_STORAGE_KEY = 'by_offers_search_state';
export const SEARCH_BY_RANGES_LOCAL_STORAGE_KEY = 'by_ranges_search_state';
export const SEARCH_ACTIVE_TAB = 'search_active_tab';
export const AGRICULTURES = [
  {
    id: 1,
    name: 'Пшеница',
    parameters: [
      {
        id: 1,
        name: 'Клейковина',
        units: '%',
        options: {
          min: 6,
          max: 55,
        },
        pivot: {
          agriculture_id: 1,
          agriculture_parameter_id: 1,
        },
      },
      {
        id: 2,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 30,
        },
        pivot: {
          agriculture_id: 1,
          agriculture_parameter_id: 2,
        },
      },
      {
        id: 3,
        name: 'ИДК',
        units: '',
        options: {
          min: 10,
          max: 110,
        },
        pivot: {
          agriculture_id: 1,
          agriculture_parameter_id: 3,
        },
      },
      {
        id: 4,
        name: 'Число падения',
        units: 'сек',
        options: {
          min: 30,
          max: 280,
        },
        pivot: {
          agriculture_id: 1,
          agriculture_parameter_id: 4,
        },
      },
      {
        id: 5,
        name: 'Протеин',
        units: '',
        options: {
          min: 5,
          max: 20,
        },
        pivot: {
          agriculture_id: 1,
          agriculture_parameter_id: 5,
        },
      },
      {
        id: 6,
        name: 'Натура',
        units: 'г/л',
        options: {
          min: 550,
          max: 900,
        },
        pivot: {
          agriculture_id: 1,
          agriculture_parameter_id: 6,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 1,
          agriculture_parameter_id: 7,
        },
      },
      {
        id: 37,
        name: 'Тип',
        units: '',
        options: {
          min: null,
          max: null,
        },
        pivot: {
          agriculture_id: 1,
          agriculture_parameter_id: 37,
        },
      },
      {
        id: 38,
        name: 'Класс',
        units: '',
        options: {
          min: null,
          max: null,
        },
        pivot: {
          agriculture_id: 1,
          agriculture_parameter_id: 38,
        },
      },
    ],
    img: '/img/Пшеница.png',
    color: '#F5EBD3',
    mixable: true,
  },
  {
    id: 2,
    name: 'Горох',
    parameters: [
      {
        id: 8,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 15,
        },
        pivot: {
          agriculture_id: 2,
          agriculture_parameter_id: 8,
        },
      },
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 2,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 10,
        name: 'Мелкий горох',
        units: '%',
        options: {
          min: 0,
          max: 8,
        },
        pivot: {
          agriculture_id: 2,
          agriculture_parameter_id: 10,
        },
      },
      {
        id: 11,
        name: 'Зерновая примесь',
        units: '%',
        options: {
          min: 0,
          max: 20,
        },
        pivot: {
          agriculture_id: 2,
          agriculture_parameter_id: 11,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 2,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Горох.png',
    color: '#C2E580',
    mixable: false,
  },
  {
    id: 3,
    name: 'Кукуруза',
    parameters: [
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 3,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 12,
        name: 'Початки в обертках',
        units: '%',
        options: {
          min: 0,
          max: 3,
        },
        pivot: {
          agriculture_id: 3,
          agriculture_parameter_id: 12,
        },
      },
      {
        id: 13,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 8,
        },
        pivot: {
          agriculture_id: 3,
          agriculture_parameter_id: 13,
        },
      },
      {
        id: 14,
        name: 'Зерновая примесь',
        units: '%',
        options: {
          min: 0,
          max: 18,
        },
        pivot: {
          agriculture_id: 3,
          agriculture_parameter_id: 14,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 3,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Кукуруза.png',
    color: '#FFCF71',
    mixable: false,
  },
  {
    id: 4,
    name: 'Просо',
    parameters: [
      {
        id: 15,
        name: 'Массовая доля ядра',
        units: '%',
        options: {
          min: 30,
          max: 90,
        },
        pivot: {
          agriculture_id: 4,
          agriculture_parameter_id: 15,
        },
      },
      {
        id: 16,
        name: 'Крупность',
        units: '%',
        options: {
          min: 20,
          max: 100,
        },
        pivot: {
          agriculture_id: 4,
          agriculture_parameter_id: 16,
        },
      },
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 4,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 17,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 10,
        },
        pivot: {
          agriculture_id: 4,
          agriculture_parameter_id: 17,
        },
      },
      {
        id: 14,
        name: 'Зерновая примесь',
        units: '%',
        options: {
          min: 0,
          max: 18,
        },
        pivot: {
          agriculture_id: 4,
          agriculture_parameter_id: 14,
        },
      },
      {
        id: 18,
        name: 'Способность прорастания',
        units: '%',
        options: {
          min: 80,
          max: 99,
        },
        pivot: {
          agriculture_id: 4,
          agriculture_parameter_id: 18,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 4,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Просо.png',
    color: '#F0C1A7',
    mixable: false,
  },
  {
    id: 5,
    name: 'Рожь',
    parameters: [
      {
        id: 19,
        name: 'Число падения',
        units: 'сек',
        options: {
          min: 75,
          max: 250,
        },
        pivot: {
          agriculture_id: 5,
          agriculture_parameter_id: 19,
        },
      },
      {
        id: 20,
        name: 'Натура',
        units: 'г/л',
        options: {
          min: 500,
          max: 900,
        },
        pivot: {
          agriculture_id: 5,
          agriculture_parameter_id: 20,
        },
      },
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 5,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 13,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 8,
        },
        pivot: {
          agriculture_id: 5,
          agriculture_parameter_id: 13,
        },
      },
      {
        id: 14,
        name: 'Зерновая примесь',
        units: '%',
        options: {
          min: 0,
          max: 18,
        },
        pivot: {
          agriculture_id: 5,
          agriculture_parameter_id: 14,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 5,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Рожь.png',
    color: '#F4F09D',
    mixable: false,
  },
  {
    id: 6,
    name: 'Ячмень',
    parameters: [
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 6,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 21,
        name: 'Натура',
        units: 'г/л',
        options: {
          min: 300,
          max: 800,
        },
        pivot: {
          agriculture_id: 6,
          agriculture_parameter_id: 21,
        },
      },
      {
        id: 11,
        name: 'Зерновая примесь',
        units: '%',
        options: {
          min: 0,
          max: 20,
        },
        pivot: {
          agriculture_id: 6,
          agriculture_parameter_id: 11,
        },
      },
      {
        id: 13,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 8,
        },
        pivot: {
          agriculture_id: 6,
          agriculture_parameter_id: 13,
        },
      },
      {
        id: 22,
        name: 'Мелкие зерна',
        units: '%',
        options: {
          min: 0,
          max: 9,
        },
        pivot: {
          agriculture_id: 6,
          agriculture_parameter_id: 22,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 6,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Ячмень.png',
    color: '#F6DAA3',
    mixable: false,
  },
  {
    id: 7,
    name: 'Овёс',
    parameters: [
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 7,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 23,
        name: 'Натура',
        units: 'г/л',
        options: {
          min: 400,
          max: 700,
        },
        pivot: {
          agriculture_id: 7,
          agriculture_parameter_id: 23,
        },
      },
      {
        id: 11,
        name: 'Зерновая примесь',
        units: '%',
        options: {
          min: 0,
          max: 20,
        },
        pivot: {
          agriculture_id: 7,
          agriculture_parameter_id: 11,
        },
      },
      {
        id: 24,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 9,
        },
        pivot: {
          agriculture_id: 7,
          agriculture_parameter_id: 24,
        },
      },
      {
        id: 25,
        name: 'Ядро',
        units: '%',
        options: {
          min: 40,
          max: 80,
        },
        pivot: {
          agriculture_id: 7,
          agriculture_parameter_id: 25,
        },
      },
      {
        id: 26,
        name: 'Кислотность',
        units: 'градусы',
        options: {
          min: 3,
          max: 10,
        },
        pivot: {
          agriculture_id: 7,
          agriculture_parameter_id: 26,
        },
      },
      {
        id: 27,
        name: 'Мелкие зерна',
        units: '%',
        options: {
          min: 0,
          max: 8,
        },
        pivot: {
          agriculture_id: 7,
          agriculture_parameter_id: 27,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 7,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Овёс.png',
    color: '#FFE68E',
    mixable: false,
  },
  {
    id: 8,
    name: 'Рыжик',
    parameters: [
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 8,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 13,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 8,
        },
        pivot: {
          agriculture_id: 8,
          agriculture_parameter_id: 13,
        },
      },
      {
        id: 28,
        name: 'Масличная примесь',
        units: '%',
        options: {
          min: 0,
          max: 15,
        },
        pivot: {
          agriculture_id: 8,
          agriculture_parameter_id: 28,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 8,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Рыжик.png',
    color: '#FCFD68',
    mixable: false,
  },
  {
    id: 9,
    name: 'Соя',
    parameters: [
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 9,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 29,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 6,
        },
        pivot: {
          agriculture_id: 9,
          agriculture_parameter_id: 29,
        },
      },
      {
        id: 28,
        name: 'Масличная примесь',
        units: '%',
        options: {
          min: 0,
          max: 15,
        },
        pivot: {
          agriculture_id: 9,
          agriculture_parameter_id: 28,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 9,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Соя.png',
    color: '#D9E6A6',
    mixable: false,
  },
  {
    id: 10,
    name: 'Рис',
    parameters: [
      {
        id: 30,
        name: 'Пожелтевшие зерна',
        units: '%',
        options: {
          min: 0,
          max: 6,
        },
        pivot: {
          agriculture_id: 10,
          agriculture_parameter_id: 30,
        },
      },
      {
        id: 31,
        name: 'Красные зерна',
        units: '%',
        options: {
          min: 0,
          max: 20,
        },
        pivot: {
          agriculture_id: 10,
          agriculture_parameter_id: 31,
        },
      },
      {
        id: 29,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 6,
        },
        pivot: {
          agriculture_id: 10,
          agriculture_parameter_id: 29,
        },
      },
      {
        id: 32,
        name: 'Зерновая примесь',
        units: '%',
        options: {
          min: 0,
          max: 10,
        },
        pivot: {
          agriculture_id: 10,
          agriculture_parameter_id: 32,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 10,
          agriculture_parameter_id: 7,
        },
      },
      {
        id: 2,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 30,
        },
        pivot: {
          agriculture_id: 10,
          agriculture_parameter_id: 2,
        },
      },
    ],
    img: '/img/Рис.png',
    color: '#E9ED6F',
    mixable: false,
  },
  {
    id: 11,
    name: 'Подсолнечник',
    parameters: [
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 11,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 33,
        name: 'Доля масла',
        units: '%',
        options: {
          min: 25,
          max: 70,
        },
        pivot: {
          agriculture_id: 11,
          agriculture_parameter_id: 33,
        },
      },
      {
        id: 34,
        name: 'Кислотность',
        units: 'мг КОН/гр',
        options: {
          min: 0,
          max: 8,
        },
        pivot: {
          agriculture_id: 11,
          agriculture_parameter_id: 34,
        },
      },
      {
        id: 17,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 10,
        },
        pivot: {
          agriculture_id: 11,
          agriculture_parameter_id: 17,
        },
      },
      {
        id: 35,
        name: 'Масличная примесь',
        units: '%',
        options: {
          min: 0,
          max: 10,
        },
        pivot: {
          agriculture_id: 11,
          agriculture_parameter_id: 35,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 11,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Подсолнечник.png',
    color: '#FFE279',
    mixable: false,
  },
  {
    id: 12,
    name: 'Нут',
    parameters: [
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 12,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 36,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 12,
        },
        pivot: {
          agriculture_id: 12,
          agriculture_parameter_id: 36,
        },
      },
      {
        id: 11,
        name: 'Зерновая примесь',
        units: '%',
        options: {
          min: 0,
          max: 20,
        },
        pivot: {
          agriculture_id: 12,
          agriculture_parameter_id: 11,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 12,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Нут.png',
    color: '#ABD26B',
    mixable: false,
  },
  {
    id: 13,
    name: 'Лён',
    parameters: [
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 13,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 13,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 8,
        },
        pivot: {
          agriculture_id: 13,
          agriculture_parameter_id: 13,
        },
      },
      {
        id: 28,
        name: 'Масличная примесь',
        units: '%',
        options: {
          min: 0,
          max: 15,
        },
        pivot: {
          agriculture_id: 13,
          agriculture_parameter_id: 28,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 13,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Лён.png',
    color: '#CFE8F0',
    mixable: false,
  },
  {
    id: 14,
    name: 'Рапс',
    parameters: [
      {
        id: 9,
        name: 'Влажность культуры',
        units: '%',
        options: {
          min: 0,
          max: 100,
        },
        pivot: {
          agriculture_id: 14,
          agriculture_parameter_id: 9,
        },
      },
      {
        id: 13,
        name: 'Сорная примесь',
        units: '%',
        options: {
          min: 0,
          max: 8,
        },
        pivot: {
          agriculture_id: 14,
          agriculture_parameter_id: 13,
        },
      },
      {
        id: 28,
        name: 'Масличная примесь',
        units: '%',
        options: {
          min: 0,
          max: 15,
        },
        pivot: {
          agriculture_id: 14,
          agriculture_parameter_id: 28,
        },
      },
      {
        id: 7,
        name: 'Температура',
        units: 'С',
        options: {
          min: 1,
          max: 100,
        },
        pivot: {
          agriculture_id: 14,
          agriculture_parameter_id: 7,
        },
      },
    ],
    img: '/img/Рапс.png',
    color: '#EAE39F',
    mixable: false,
  },
];
